import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';



import { GlobalLeadPartnerPopupRoutingModule } from './global-lead-partner-popup-routing.module';
import { GlobalLeadPartnerPopupComponent } from './global-lead-partner-popup.component';


@NgModule({
  declarations: [
    GlobalLeadPartnerPopupComponent
  ],
  imports: [
    CommonModule,
    GlobalLeadPartnerPopupRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    SharedModule,
  ]
})
export class GlobalLeadPartnerPopupModule { }
